export enum MessageStatus {
  DRAFT,
  SENDING,
  SENT,
  ERROR
}
